import React from 'react';
import {
  BsArrowRight
} from "react-icons/bs";
import { Link } from "react-router-dom";
import i from "../../../images/frontend-development.jpg";
import node from "../../../images/node2.png";
import react from "../../../images/react-development-icon.svg";
import wordpress from "../../../images/wordpress-logo.svg";
function AboutService() {
  return (
    <div className='about-service-section'>
           <div className="margin_container">


           <div className='about-service-flex'>
                < div className='left'>
                    <div className="image-area">
                        <img src={i} alt="" />
                    </div>
                </div>
                <div className='right'>

                  <div className="right-one">
                    <h2>Full stack web development</h2>
                    <p>React.js to pixel perfect responsive layouts. I build amazing Frontend interfaces that are responsive, fast and well integrated with backend services.</p>
                   <Link to="/service" style={{textDecoration:"none"}}> <button>Full stack development <BsArrowRight/></button></Link>
                  </div>
                  <div className="right-two">
                    <div className="right-render-items">
                        <Link to="/service" className="item">
                            <div className="img">
                                <img src={react} alt="" />
                            </div>
                            <div className="text">React development</div>
                        </Link>

                        <Link to="/service" className="item">
                            <div className="img">
                                <img src={node} alt="" />
                            </div>
                            <div className="text">Nodejs development</div>
                        </Link>


                        <Link to="/service" className="item">
                            <div className="img">
                                <img src={wordpress} alt="" />
                            </div>
                            <div className="text">Wordpress Development</div>
                        </Link>
                    </div>
                  </div>
                </div>
           </div>




           
           </div>
    </div>
  )
}

export default AboutService